import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Badge = lib.styled.div`
  width: 8px;
  margin-top: 20px;
  margin-left: -27px;
  margin-right: 15px;
  height: 8px;
  border: 2px solid ${colors.white};
  border-radius: 50%;
  background-color: ${(props: any) => props.color};
  outline: none;
  z-index: 1;
`;
